import { FC } from 'react'

import { Icon } from '../Icon'

import { MaskProps } from './types'

export const Mask: FC<MaskProps> = ({ id, percentage = 100, ...props }) => (
  <Icon width="0" height="0" viewBox="0 0 16 16" fill="none" {...props}>
    <mask id={id}>
      <rect x="0" y="0" width="64" height="64" fill="white" />
      <rect x={`${percentage}%`} y="0" width="64" height="64" fill="black" />
    </mask>
  </Icon>
)
